import type { ReactNode } from "react";

import type { LucideIcon } from "lucide-react";
import { motion } from "motion/react";

import { cn } from "@/lib/utils";

/**
 * Bo'lim — oq karta va rangli ikonkali sarlavha (web ilovadagi `Panel`).
 * Jadvallar bunga o'ralmaydi: ular sahifa fonida turadi.
 */
export function Panel({
  icon: Icon,
  tone,
  title,
  description,
  aside,
  children,
  className,
  delay = 0,
}: {
  icon: LucideIcon;
  /** Ikonka foni va rangi, masalan `bg-tile-sky text-tile-sky-strong`. */
  tone: string;
  title: string;
  description?: ReactNode;
  aside?: ReactNode;
  children: ReactNode;
  className?: string;
  delay?: number;
}) {
  return (
    <motion.section
      initial={{ opacity: 0, y: 14 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.5, delay, ease: [0.16, 1, 0.3, 1] }}
      className={cn(
        "bg-card shadow-foreground/[0.03] space-y-4 rounded-2xl border p-4 shadow-sm sm:p-5",
        className,
      )}
    >
      <div className="flex flex-wrap items-center gap-2">
        <span className={cn("flex size-7 items-center justify-center rounded-lg", tone)}>
          <Icon className="size-4" aria-hidden />
        </span>
        <div className="min-w-0">
          <h2 className="text-base font-semibold">{title}</h2>
          {description ? <p className="text-muted-foreground text-xs">{description}</p> : null}
        </div>
        {aside ? <div className="ml-auto">{aside}</div> : null}
      </div>
      {children}
    </motion.section>
  );
}
